import React, { useRef } from 'react';

import Dropzone from '../Dropzone';
import UploadProgress from '../Dropzone/UploadProgress';
import { useFileInput } from '../hooks/useFileInput';
import { InputRenderer } from '../types';

import HiddenInput from './HiddenInput';

const FileInput = ({ inputProps, required }: InputRenderer) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [handleFileChange, progress, preview] = useFileInput(inputProps.value, inputProps.onChange);

  const openDialog = React.useCallback(() => {
    const { current } = inputRef;

    if (!current) {
      throw new Error('No input ref on dropzone');
    }

    current.click();
  }, [inputRef]);

  return (
    <React.Fragment>
      {required && <HiddenInput inputProps={inputProps} required={required} />}
      {progress !== undefined ? (
        <UploadProgress value={progress} />
      ) : (
        <Dropzone
          clearable={!required}
          inputRef={inputRef}
          name={inputProps.name ?? ''}
          openDialog={openDialog}
          preview={preview}
          onChange={handleFileChange}
        />
      )}
    </React.Fragment>
  );
};

export default FileInput;
